import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation.ts';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';

import css from './unsupported-browser.css';


export const UnsupportedBrowser = () => {
  const {t} = useLabelTranslation();

  return (
    <EmptyState
      classNames={{
        wrapper: css.wrapper,
      }}
      imageVariant="calendar"
      title={t('Browser_Not_Supported', 'Browser Not Supported')}
      description={t(
        'You\'re_using_an_unsupported_browser_For_the_best_experience_on_sense_please_be_sure_you\'re_using_the_latest_versions_of_Chrome_Firefox_Safari_or_Microsoft_Edge',
        'You\'re using an unsupported browser. For the best experience on sense, please be sure you\'re using the latest versions of Chrome, Firefox, Safari or Microsoft Edge',
      )}
      testId="cb-unsupported-browser"
    />
  );
};
